import React, { useState } from "react";
// Components
import { Dropdown, Header, Image, Icon, Button } from "semantic-ui-react";
import { CheckBox } from "../atoms/Images";
// Constants
import { newStatus, cellActionTypes } from "../../model/Table";
import i18nstring, { strings } from "../../i18n";
// Images
import Avatar from "../../images/icons/avatar.png";
import PlaceHolder from "../../images/icons/placeHolder.png";
// Themes
import "./AtomStyles.scss";
import ConfirmationPopup from "./ConfirmationPopup";

export function ApprovalCellNonProfit({
  changeApproval,
  impersonate,
  isApproved,
  userId
}) {
  const impersonateUser = () => {
    impersonate(userId);
  };
  const approveUser = event => {
    if (event) {
      event.preventDefault();
    }
    changeApproval(i18nstring(strings.APPROVED), [userId]);
  };
  return isApproved ? (
    <div className="impersonate_cell" onClick={impersonateUser}>
      {i18nstring(strings.VIEW_AS)}
    </div>
  ) : (
    <div className="table_cell_action" onClick={approveUser}>
      <Icon name="check" color="green" size="large" />
    </div>
  );
}

export function ApprovalCell({ changeApproval, isApproved, userId }) {
  const approveUser = event => {
    if (event) {
      event.preventDefault();
    }
    changeApproval(i18nstring(strings.APPROVED), [userId]);
  };
  return isApproved ? null : (
    <div className="table_cell_action" onClick={approveUser}>
      <Icon name="check" color="green" size="large" />
    </div>
  );
}

export function DenyCell({ changeApproval, userId }) {


  const denyUser = event => {
    if (event) {
      event.preventDefault();
    }
    changeApproval(i18nstring(strings.PENDING), [userId]);
  };
  return (
      <div className="table_cell_action" onClick={denyUser}>
        <Icon name="cancel" color="orange" size="large" />
      </div>
  )
}

export function ActionCell({ approved, approveCourier, id, type }) {
  const handleSubmit = event => {
    if (event) {
      event.preventDefault();
    }
  };

  switch (type) {
    case cellActionTypes.APPROVE:
      return approved === newStatus.APPROVED ? null : (
        <Button type="submit" onClick={handleSubmit} />
      );
    case cellActionTypes.DENY:
      return (
        <Header.Content className="action_cell">
          <Icon name="cancel" color="orange" size="large" />
        </Header.Content>
      );
    default:
      return (
        <Header.Content className="action_cell">
          <Icon
            name="ellipsis horizontal"
            size="large"
            onClick={() => console.log("open modal")}
          />
          {i18nstring(strings.MORE)}
        </Header.Content>
      );
  }
}

export function MiscCell({ label }) {
  return <div className="table_cell">{label}</div>;
}

export function RadioCell({ options, selectStatus }) {
  return options.map((option, index) => {
    const { action, active, label, unavailable } = option;
    const selectThisStatus = () => selectStatus(action);
    let cellStyle = unavailable ? "radio_cell_inactive" : "radio_cell";
    return (
      <div
        key={index}
        onClick={selectThisStatus}
        className={active ? "radio_cell_active" : cellStyle}
      >
        {label}
      </div>
    );
  });
}

export function MarkCompletedCell({ options, selectStatus }) {
  return options.map((option, index) => {
    const { action, label, unavailable } = option;
    const selectThisStatus = () => selectStatus(action);
    let cellStyle = unavailable
      ? "mark_completed_cell_inactive"
      : "mark_completed_cell";
    return (
      <div key={index} className={cellStyle}>
        <div
          onClick={selectThisStatus}
          className={"mark_completed_cell_button"}
        >
          {label}
        </div>
      </div>
    );
  });
}

export function EditableCell(props) {
  const { updatedWeights, handleUpdateWeights, item } = props;
  const { pickUpWeight, weight, id } = item;

  const initialWeight = pickUpWeight ? pickUpWeight : weight;
  const [newWeight, setNewWeight] = useState(initialWeight);
  const handleInputChange = event => {
    event.persist();
    setNewWeight(event.target.value);
    handleUpdateWeights({ id: item.id, updatedWeight: event.target.value });
    // changeWeight(newItem);
  };
  const weightIsUpdated = updatedWeights[id] !== undefined;
  const weightValid = parseInt(newWeight) >= 0 || newWeight === "";

  const cellStyle = {
    borderWidth: 0,
    padding: 10,
    borderLeftWidth: 0,
    color: weightIsUpdated ? "white" : null,
    backgroundColor: !weightValid ? "red" : weightIsUpdated ? "#d9912a" : null
  };
  return (
    <input style={cellStyle} onChange={handleInputChange} value={newWeight} />
  );
}

export function UserCell({ user, isSelected, selectUser }) {
  // const avatar = user.photoURL ? user.photoURL : Avatar;
  const avatar = Avatar;
  return (
    <div className="table_cell_user">
      <CheckBox isChecked={isSelected} toggleCheckBox={selectUser} />
      <div className="table_cell_image">
        <Image className="avatar_image" src={avatar} circular />
      </div>
      <div className="user_name_cell">{user.name}</div>
    </div>
  );
}

export function ItemCell({ item }) {
  const avatar = item.photoURL ? item.photoURL : PlaceHolder;
  return (
    <div className="table_cell_item">
      <div className="table_cell_image">
        <Image className="avatar_image" src={avatar} circular />
      </div>
      <div className="user_name_cell">{item.name}</div>
    </div>
  );
}

export function DeleteCell({ deleteItem, itemId }) {

  const deleteData = event => {
    if (event) {
      event.preventDefault();
    }
    deleteItem(itemId);
  };
  return (
      <div className="table_cell_delete_action" onClick={deleteData}>
        <Icon name='trash alternate' color="orange" size="large" />
      </div>
  )
}

export function UserAvatar({ photoURL }) {
  return (
    <Image
      src={photoURL || Avatar}
      className="initials_avatar"
      style={{ objectFit: "cover" }}
      circular
    />
  );
}

export function ReviewActions({ user, tabStatus, changeApproval }) {
  const [confirmDisapprove, setConfirmDisapprove] = useState(false);
  const [confirmDeactivate, setConfirmDeactivate] = useState(false);
  const [confirmReactivate, setConfirmReactivate] = useState(false);

  const approve = () => changeApproval(newStatus.APPROVED, [user.id]);
  const disapprove = () => changeApproval(newStatus.PENDING, [user.id], true);
  const deactivate = () => changeApproval(newStatus.DEACTIVATE, [user.id], true);
  const reactivate = () => changeApproval(newStatus.REACTIVATE, [user.id]);

  if (tabStatus === newStatus.PENDING) {
    return (
      <div className="review_approve_btn" onClick={approve} title={i18nstring(strings.APPROVE)}>
        <Icon name="check" color="teal" />
        {i18nstring(strings.APPROVE)}
      </div>
    );
  }

  if (tabStatus === newStatus.APPROVED) {
    return (
      <>
        <Dropdown
          trigger={
            <div className="review_action_btn">
              <Icon name="ellipsis vertical" style={{ color: "#888", fontSize: "1rem" }} />
            </div>
          }
          pointing="top right"
          icon={null}
        >
          <Dropdown.Menu>
            <Dropdown.Item onClick={() => setConfirmDisapprove(true)}>
              <Icon name="undo" />
              {i18nstring(strings.UNAPPROVE)}
            </Dropdown.Item>
            <Dropdown.Item onClick={() => setConfirmDeactivate(true)} className="dropdown_item_deactivate">
              <Icon name="ban" color="red" />
              {i18nstring(strings.DEACTIVATE)}
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>

        <ConfirmationPopup
          open={confirmDisapprove}
          setOpen={setConfirmDisapprove}
          title={i18nstring(strings.UNAPPROVE)}
          message={i18nstring(strings.DISAPPROVE_CONFIRMATION_MESSAGE)}
          primaryButtonText={i18nstring(strings.UNAPPROVE)}
          onPrimaryButtonClicked={disapprove}
        />

        <ConfirmationPopup
          open={confirmDeactivate}
          setOpen={setConfirmDeactivate}
          title={i18nstring(strings.DEACTIVATE)}
          message={i18nstring(strings.DEACTIVATE_CONFIRMATION_MESSAGE)}
          primaryButtonText={i18nstring(strings.DEACTIVATE)}
          onPrimaryButtonClicked={deactivate}
        />
      </>
    );
  }

  if (tabStatus === newStatus.DEACTIVATE) {
    return (
      <>
        <div className="review_reactivate_btn" onClick={() => setConfirmReactivate(true)}>
          <Icon name="redo alternate" color="teal" />
          {i18nstring(strings.REACTIVATE)}
        </div>

        <ConfirmationPopup
          open={confirmReactivate}
          setOpen={setConfirmReactivate}
          title={i18nstring(strings.REACTIVATE)}
          message={i18nstring(strings.REACTIVATE_CONFIRMATION_MESSAGE)}
          primaryButtonText={i18nstring(strings.REACTIVATE)}
          onPrimaryButtonClicked={reactivate}
        />
      </>
    );
  }

  return null;
}